import './ShinyText.css';
import { useEffect } from 'react';

const ShinyText = ({ text, disabled = false, speed = 5, className = '', onClick, onTouchEnd }) => {
  const animationDuration = `${speed}s`;

  useEffect(() => {
    console.log('ShinyText component rendered with text:', text);
  }, [text]);

  return (
    <span
      className={`shiny-text ${className} ${disabled ? 'disabled' : ''}`}
      style={{ animationDuration }}
      onClick={onClick}
      onTouchEnd={onTouchEnd}
    >
      {text}
    </span>
  );
};

export default ShinyText;
